import Image from "next/image"
import AicpaSoc from "public/images/auth/security/aicpa-soc.png"
import Ccpa from "public/images/auth/security/ccpa.png"
import Gdpr from "public/images/auth/security/gdpr.png"
import Nist from "public/images/auth/security/nist.png"
import Scim from "public/images/auth/security/scim.png"
import Sso from "public/images/auth/security/sso.png"

import { cn } from "@/lib/utils"

const SECURITY_BADGES = [
  { src: Sso, alt: "Single sign-on (SSO)" },
  { src: Scim, alt: "SCIM provisioning" },
  { src: AicpaSoc, alt: "AICPA SOC 2 compliant" },
  { src: Gdpr, alt: "GDPR compliant" },
  { src: Ccpa, alt: "CCPA compliant" },
  { src: Nist, alt: "NIST aligned" },
]

export function SignupSecurityBadges({ className }: { className?: string }) {
  return (
    <div className={cn("flex w-full flex-col items-center gap-3", className)}>
      <div className="flex w-full flex-wrap items-center justify-center gap-x-5 gap-y-3">
        {SECURITY_BADGES.map((badge) => (
          <div
            key={badge.alt}
            className="relative h-9 w-9 opacity-70 grayscale transition-all duration-200 hover:opacity-100 hover:grayscale-0"
          >
            <Image
              src={badge.src}
              alt={badge.alt}
              fill
              sizes="36px"
              className="object-contain"
            />
          </div>
        ))}
      </div>
    </div>
  )
}
